import React, {useEffect} from "react";



const IntroPage = ({nextComponent}) => {
  useEffect(()=>{
    window.scrollTo({top:0, left:0, behaviour:'smooth'})
  },[])
   
    const handleClick = ()=>{
        nextComponent()
    }

  return (
    <div className="main_content" id="main-content">
      <div className="page">
        <div className="flex-column">
          <div className="kiddies_hero"></div>

          <div className="kiddies_hero-tablet"></div>

          <div className="kiddies_hero-mobile"></div>

          <div className="col-lg-12  m-b-50 ">
            <section className="step-wizard m-b-30">
              <ul className="step-wizard-list">
                <li className="step-wizard-item m-b-10 current-item">
                  <span className="progress-count">1</span>
                  <span className="progress-title">
                    <a href="guardian_page.html">Introduction</a>
                  </span>
                </li>
                <li className="step-wizard-item ">
                  <span className="progress-count">2</span>
                  <span className="progress-title">Child Information</span>
                </li>
                <li className="step-wizard-item">
                  <span className="progress-count">3</span>
                  <span className="progress-title">Guardian Information</span>
                </li>
                {/* <li className="step-wizard-item">
                  <span className="progress-count">4</span>
                  <span className="progress-title">Upload Documents</span>
                </li> */} 
                <li className="step-wizard-item">
                  <span className="progress-count">4</span>
                  <span className="progress-title">Review Information</span>
                </li>
              </ul>
            </section>

            <section className="step-wizard-tablet m-b-30">
              <ul className="step-wizard-list">
                <li className="step-wizard-item m-b-10">
                  <span className="progress-count">1</span>
                  <span className="progress-title">Introduction</span>
                </li>
                <li className="step-wizard-item current-item">
                  <span className="progress-count">2</span>
                  <span className="progress-title">Child Information</span>
                </li>
                <li className="step-wizard-item">
                  <span className="progress-count">3</span>
                  <span className="progress-title">Guardian Information</span>
                </li>
                {/* <li className="step-wizard-item">
                  <span className="progress-count">4</span>
                  <span className="progress-title">Upload Documents</span>
                </li> */}
                <li className="step-wizard-item">
                  <span className="progress-count">4</span>
                  <span className="progress-title">Review Information</span>
                </li>
              </ul>
            </section>

            <div className="tab-content p-30" id="myTabContent">
              <div
                className="fade show active"
                id="account_spec"
                role="tabpanel"
                aria-labelledby="account_spec-tab"
              >
                {/* <!-- PERSONAL DETAILS --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-user m-r-5"></i> Document Requirements
                  </div>

                  <div className="row">
                    <div className="col-lg-12 d-flex">
                      <div className="p-10 col-lg-3 m-r-30">
                        <div className="section-sub-text font-weight-300 font-14 text-gray">
                          Welcome! Thank you for choosing SunTrust Bank Nigeria.
                          To get started, ensure the listed documents are
                          readily available for uploads.
                        </div>
                      </div>

                      <div className="section-forms p-10 col-lg-9">
                        <div className="col-lg-12">
                          <div className="row">
                            <p className="font-14">
                              List of Requirements to Open a Kiddies Account
                            </p>

                            <ol className="font-14">
                              <li>
                                One Passport photograph of each signatory and
                                Child showing full face forward.
                              </li>
                              <li>
                                Identification document for each signatory e.g.
                                International Passport, National Drivers
                                license, National Identity card, etc. Please
                                bring along the original for sighting.
                              </li>
                              <li>
                                Copy of a utility bill issued within the last
                                three months showing address. Please bring along
                                the original for sighting
                              </li>
                              <li>
                                Copy of Child's birth certificate. Please bring
                                along the original for sighting (NPC (National
                                Population Census Certificate)
                              </li>
                              <li>
                                Letter of Sponsorship identification from
                                Parents (For Guardian / Sponsor only)
                              </li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group col-lg-12 col-md-12 col-sm-12 m-b-20">
                  <div className="d-flex align-items-center justify-content-center m-t-20">
                    <div className="user_acct_details col-lg-3 col-md-6 col-sm-12 m-b-10">
                      <button
                        className="btn btn-block btn-suntrust font-weight-500"
                        onClick={handleClick}
                      >
                        Next Page
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroPage;
